import { sanitizeString } from './'
import { getCleanedPath, getLocaleUrl } from './localeUtils'

export const createPagePath = ({ item, customPath = null }) => {
  const locale = getLocaleUrl()
  const linkELements = [
    item?.basePath || item?.teaserContent?.basePath,
    sanitizeString(item?.category || item?.teaserContent?.category),
    item?.slug?.current || item?.teaserContent?.slug?.current,
    item?.path,
    item?.url || item?.customLink,
    customPath
  ]

  // console.log(
  //   linkELements
  //     .filter(path => path !== null)
  //     .join('/')
  //     .replace(/(\/)+/gi, '/') // remove double-slashes
  //     .replace(/\/$/, '') // remove trailing slashes
  // )
  const LinkElementsToClean = linkELements
    .filter(path => path !== null)
    .join('/')
    .replace(/(\/)+/gi, '/') // remove double-slashes
    .replace(/\/$/, '') // remove trailing slashes

  return getCleanedPath(locale, LinkElementsToClean)
}
